var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.461,
    height: 62.461,
    viewBox: "0 0 62.461 62.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "help_FILL0_wght400_GRAD0_opsz48",
    d: "M111.543,225.422a2.933,2.933,0,1,0-2.108-.859A2.866,2.866,0,0,0,111.543,225.422Zm-2.733-11.4h4.606a12.779,12.779,0,0,1,.507-3.709,9.193,9.193,0,0,1,3.162-3.865,13.661,13.661,0,0,0,3.435-3.982,9.166,9.166,0,0,0,1.015-4.294,8.62,8.62,0,0,0-2.694-6.636,10.087,10.087,0,0,0-7.144-2.5,12.068,12.068,0,0,0-6.754,1.913,10.925,10.925,0,0,0-4.255,5.27l4.138,1.562a7.285,7.285,0,0,1,2.577-3.4,6.868,6.868,0,0,1,4.06-1.21,6.258,6.258,0,0,1,4.294,1.444,4.718,4.718,0,0,1,1.64,3.709,5.74,5.74,0,0,1-1.015,3.24,15.553,15.553,0,0,1-2.967,3.162,15.879,15.879,0,0,0-3.474,4.021A10.628,10.628,0,0,0,108.81,214.023Zm2.42,24.438A30.218,30.218,0,0,1,99.129,236a31.465,31.465,0,0,1-16.669-16.669,31.2,31.2,0,0,1,0-24.282,31.211,31.211,0,0,1,6.715-9.916,32.014,32.014,0,0,1,9.955-6.676,31.2,31.2,0,0,1,24.282,0A31.182,31.182,0,0,1,140,195.051a31.2,31.2,0,0,1,0,24.282,32.014,32.014,0,0,1-6.675,9.955A31.211,31.211,0,0,1,123.41,236,30.41,30.41,0,0,1,111.23,238.461Zm0-4.685a26.546,26.546,0,1,0-18.777-45.362,26.565,26.565,0,0,0,18.777,45.362ZM111.23,207.23Z",
    transform: "translate(-80 -176)",
    fill: "#a21110"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning_circle.777825a394a0b58082e2657253f3ef03.svg";
export { ForwardRef as ReactComponent };